import { ref } from 'vue'
import { getDicts } from '@/api/dict'

const dictCache = new Map()

function loadDict(dictType) {
  if (!dictCache.has(dictType)) {
    dictCache.set(dictType, getDicts(dictType).catch(error => {
      dictCache.delete(dictType)
      throw error
    }))
  }
  return dictCache.get(dictType)
}

export async function loadDictMap(...dictTypes) {
  const uniqueTypes = [...new Set(dictTypes.filter(Boolean))]
  const dictList = await Promise.all(uniqueTypes.map(type => loadDict(type)))
  return uniqueTypes.reduce((result, type, index) => {
    result[type] = dictList[index] || []
    return result
  }, {})
}

export function useDict(...dictTypes) {
  const uniqueTypes = [...new Set(dictTypes.filter(Boolean))]
  const dictRefs = uniqueTypes.reduce((result, type) => {
    result[type] = ref([])
    return result
  }, {})
  let loadingPromise = null

  const loadDicts = async () => {
    if (loadingPromise) {
      return loadingPromise
    }
    loadingPromise = Promise.all(uniqueTypes.map(async type => {
      dictRefs[type].value = await loadDict(type) || []
    })).finally(() => {
      loadingPromise = null
    })
    return loadingPromise
  }

  loadDicts()

  return {
    ...dictRefs,
    loadDicts
  }
}

/**
 * 根据字典数组和值查找对应的标签
 * @param {Array} dictList - 字典数组
 * @param {String|Number} value - 要查找的值
 * @param {String} separator - 分隔符（用于多选场景，如 ','）
 * @returns {String} 对应的标签文本
 */
export function selectDictLabel(dictList, value, separator) {
  if (value === undefined || value === null || value === '' || !dictList || !dictList.length) return '-'
  
  // 如果是多选（有分隔符）
  if (separator && typeof value === 'string' && value.includes(separator)) {
    const values = value.split(separator).map(v => v.trim()).filter(Boolean)
    const labels = values.map(v => {
      const item = dictList.find(d => String(d.dictValue) === String(v))
      return item ? item.dictLabel : v
    }).filter(Boolean)
    return labels.join('、') || '-'
  }
  
  // 单选
  const item = dictList.find(d => String(d.dictValue) === String(value))
  return item ? item.dictLabel : '-'
}
